import { render, staticRenderFns } from "./chanyelanddetail.vue?vue&type=template&id=11897810&scoped=true"
import script from "./chanyelanddetail.vue?vue&type=script&lang=js"
export * from "./chanyelanddetail.vue?vue&type=script&lang=js"
import style0 from "./chanyelanddetail.vue?vue&type=style&index=0&id=11897810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11897810",
  null
  
)

export default component.exports